import { TextField } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { change } from '../../../store/actions/account.action'
import { FaPlus } from 'react-icons/fa';

const Mercadopago = (props) => {
    const dispatch = useDispatch();
    const { account, error } = useSelector(state => state.accountReducer)

    return (
        <>
            <div className="mb-3">
                <label className="label-custom bs-color-b">CODE</label>
                <TextField
                    disabled={(props.id)}
                    error={(error.code) && true}
                    placeholder="Informe o código solicitado"
                    value={account.code || ''}
                    onChange={ e => dispatch(change({code: e.target.value}))}
                />

                {(error.code) &&
                    <strong className="text-danger">{error.code[0]}</strong>
                }
            </div>

            <div className="mb-3">
                <a href="https://auth.mercadopago.com.br/authorization?client_id=2092805717840015&response_type=code&platform_id=mp&state=RANDOM_ID&redirect_uri=https://api.eedgecloud.com/mercadopago/redirect" target="_blank" rel="noopener noreferrer">
                    <button type="button" className="btn btn-sm btn-success rounded-0">
                        <FaPlus size="1em" className="me-2" /> Solicitar Código
                    </button>
                </a>
            </div> 
        </>
    )
}


export default Mercadopago